export default class DetailNewCustomerRequest
{
    constructor(
        public newCustomerId: number
    ) {
    }
}
